import {signal} from "@preact/signals"

export const userSignal = signal(null)